/* eslint-disable no-undef */
<template>
  <div>
    <Row style="height: 3vh" class="replace">
      <Col :xs="18" :sm="18" :md="18" :lg="18" style="height: 100%;letter-spacing:5px;" class="title-header">
      <svg-icon style="cursor:pointer" icon-class="isscollop" :className="isscollop" @click.native.prevent="collapse()" />{{systemInfo.v_system_title}}
      </Col>
      <Col :xs="6" :sm="6" :md="6" :lg="6" style="height: 100%" class="headerUser">
      <Menu mode="horizontal">
        <Submenu name="4">
          <template slot="title">{{username? username :'请完善信息'}}</template>
          <MenuGroup title="操作">
            <MenuItem @click.native="DrawerFlag = true" name="3-1">我的信息</MenuItem>
            <!-- <MenuItem name="3-2">反馈意见</MenuItem> -->
            <MenuItem @click.native="loginOut()" name="3-3">退出登录</MenuItem>
          </MenuGroup>
          <!-- <MenuGroup title="关于">
            <MenuItem name="3-4">公告</MenuItem>
            <MenuItem name="3-5">关于系统</MenuItem>
          </MenuGroup> -->
        </Submenu>
      </Menu>
      <svg-icon style="cursor:pointer" class="amplification" :icon-class="flag % 2 == 0?'amplification':'shrink'"
        @click.native.prevent="toggleFullscreen()" />
      </Col>
    </Row>
    <Drawer title="我的信息" width="35" :mask-closable="false" :closable="true" v-model="DrawerFlag">
      <CellGroup>
        <Cell title="用户名" :extra="userInfoDetail.vUserId? userInfoDetail.vUserId: '--'" />
        <Cell title="角色" :extra="userInfoDetail.roleName? userInfoDetail.roleName: '--'" />
        <Cell title="所属部门" :extra="userInfoDetail.deptName? userInfoDetail.deptName: '--'" />
        <Cell title="姓名" :extra="userInfoDetail.vName? userInfoDetail.vName: '--'" />
        <Cell title="电话" :extra="userInfoDetail.vMobile? userInfoDetail.vMobile: '--'" />
        <Cell title="邮箱" :extra="userInfoDetail.vEmail? userInfoDetail.vEmail: '--'" />
        <Cell title="当前状态" selected :extra="userInfoDetail.iStatus === 0 ? '正常':'不正常'" />
      </CellGroup>
      <div style="height: 40px" />
      <Row style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center;">
        <Button style="margin-right: 4px" @click="DrawerFlag = false">关闭</Button>
        <Button style="margin-right: 4px" type="primary" @click="DrawerPasswordFlag = true">修改密码</Button>
        <Button type="primary" @click="userInfoInputFlag = true">完善信息</Button>
      </Row>
      <Spin size="large" fix v-if="spinShow1"></Spin>
    </Drawer>
    <Drawer title="修改密码" @on-close="handleReset('ruleValiChangePassword')" width="25" :mask-closable="false" :closable="true" v-model="DrawerPasswordFlag">
      <!-- <userInfo /> -->
      <Form ref="ruleValiChangePassword" label-position="right" :rules="ruleValiChangePassword"  :model="changePasswordInfo" :label-width="100">
        <FormItem v-show="false" label="用户名" prop="vUserId">
          <Input type="text" :disabled="true" v-model="changePasswordInfo.vUserId">
          <Icon type="ios-contact" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem label="原密码" prop="oldPassword">
          <Input type="password" v-model="changePasswordInfo.oldPassword" placeholder="请输入旧密码">
          <Icon type="ios-lock-outline" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem label="新密码" prop="newPassword">
          <Input type="password" v-model="changePasswordInfo.newPassword" placeholder="请输入新密码">
          <Icon type="ios-lock-outline" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem label="确认新密码" prop="changePassword">
          <Input type="password" v-model="changePasswordInfo.changePassword" placeholder="请再次确认新密码">
          <Icon type="ios-lock-outline" slot="prepend"></Icon>
          </Input>
        </FormItem>
      </Form>
      <div style="height: 40px" />
      <Row style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center;">
        <Button style="margin-right: 4px" @click="DrawerPasswordFlag = false">关闭</Button>
        <Button style="margin-right: 4px" type="primary" @click="changePassword()">确定</Button>
      </Row>
    </Drawer>
    <Drawer title="完善信息" @on-close="handleReset('formValidateUserInfo')" width="25" :mask-closable="false" :closable="true" v-model="userInfoInputFlag">
      <Form ref="formValidateUserInfo" label-position="right" :rules="ruleValidate" :model="userInfomodify" :label-width="80">
        <FormItem label="用户名" prop="vUserId">
          <Input type="text" :disabled="true" v-model="userInfomodify.vUserId">
          <Icon type="ios-contact" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem label="角色" prop="roleName">
          <Input type="text" :disabled="true" v-model="userInfomodify.roleName">
          <Icon type="md-bowtie" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem label="所属部门" prop="deptName">
          <Input type="text" :disabled="true" v-model="userInfomodify.deptName">
          <Icon type="md-home" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem label="姓名" prop="vName">
          <Input type="text" v-model="userInfomodify.vName">
          <Icon type="ios-person" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem label="电话" prop="vMobile">
          <Input type="text" v-model="userInfomodify.vMobile">
          <Icon type="ios-phone-portrait" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem label="邮箱" prop="vEmail">
          <Input type="text" v-model="userInfomodify.vEmail">
          <Icon type="md-mail" slot="prepend"></Icon>
          </Input>
        </FormItem>
      </Form>
      <div style="height: 40px" />
      <Row style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center;">
        <Button style="margin-right: 4px" @click="userInfoInputFlag = false">关闭</Button>
        <Button style="margin-right: 4px" type="primary" @click="editUser()">提交</Button>
      </Row>
      <Spin size="large" fix v-if="spinShow2"></Spin>
    </Drawer>
  </div>
</template>
<script>
import header from './js/header.js'
import { setUSERINFO } from '../../store/cookies/index.js'
import { getUserDetail, editUser, changeUserPassword } from '@/api/management/userApi.js'
export default {
  mixins: [header],
  data() {
    return {
      formCustom: {
        clunm: ''
      },
      spinShow1: false,
      spinShow2: false,
      DrawerPasswordFlag: false,
      userInfoInputFlag: false,
      userInfoDetail: {}, // 用户详情所需对象
      userInfomodify: {}, // 用户修改所需对象
      changePasswordInfo: {
        vUserId: '',
        oldPassword: '',
        newPassword: '',
        changePassword: ''
      }, // 修改密码所需对象
      ruleValiChangePassword: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        changePassword: [
          { required: true, message: '请确认密码', trigger: 'blur' }
        ]
      },
      ruleValidate: {
        vUserId: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        deptName: [
          { required: true, message: '部门不能为空', trigger: 'blur' }
        ],
        roleName: [
          { required: true, message: '角色不能为空', trigger: 'blur' }
        ],
        vEmail: [
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' },
          { type: 'string', max: 100, message: '邮箱不能超过100位', trigger: 'blur' }
        ],
        vMobile: [
          { required: false, max: 11, message: '手机号最大长度为11位', trigger: 'blur' }
        ],
        vName: [
          { required: false, message: '姓名', trigger: 'blur' },
          { type: 'string', max: 50, message: '姓名不能超过50位', trigger: 'blur' }
        ]
      }
    }
  },
  created() {},
  methods: {
    // 退出登录
    loginOut() {
      this.$Modal.confirm({
        title: '退出系统',
        content: '<p>确定退出系统吗？</p>',
        loading: true,
        onOk: () => {
          this.$router.replace('/login')
          this.$Modal.remove()
        }
      })
    },
    editUser() {
      this.$refs['formValidateUserInfo'].validate((valid) => {
        if (valid) {
          editUser(this.userInfomodify).then(res => {
            if (res.data.code === '0000') {
              this.spinShow1 = true
              const userInfo = JSON.parse(this.$store.getters['menu/getUSERINFO'])
              getUserDetail({
                userId: userInfo.vUserId
              }).then(res => {
                if (res.data.code === '0000') {
                  this.userInfoDetail = res.data.info
                  setUSERINFO(JSON.stringify(this.userInfoDetail))
                  this.$store.commit('menu/setUSERINFO', JSON.stringify(this.userInfoDetail))
                  const userInfo = JSON.parse(this.$store.getters['menu/getUSERINFO'])
                  this.username = userInfo.vName
                  this.spinShow1 = false
                }
              })
              this.userInfoInputFlag = false
            }
          })
        }
      })
    },
    changePassword() {
      this.$refs['ruleValiChangePassword'].validate((valid) => {
        if (valid) {
          if (this.changePasswordInfo.newPassword !== this.changePasswordInfo.changePassword) {
            return this.$Message.warning({
              content: '两次密码输入不一致',
              duration: 5
            })
          }
          const userInfo = JSON.parse(this.$store.getters['menu/getUSERINFO'])
          this.changePasswordInfo.vUserId = userInfo.vUserId
          changeUserPassword(this.changePasswordInfo).then(res => {
            if (res.data.code === '0000') {
              this.$Message.success({
                content: '修改密码成功,请重新登录!',
                duration: 5
              })
              this.$router.push('/login')
            }
          })
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields()
    }
  },
  watch: {
    DrawerFlag: function(newObj, oldObj) {
      this.spinShow1 = true
      if (newObj) {
        const userInfo = JSON.parse(this.$store.getters['menu/getUSERINFO'])
        getUserDetail({
          userId: userInfo.vUserId
        }).then(res => {
          if (res.data.code === '0000') {
            this.userInfoDetail = res.data.info
            setUSERINFO(JSON.stringify(this.userInfoDetail))
            this.$store.commit('menu/setUSERINFO', JSON.stringify(this.userInfoDetail))
            this.spinShow1 = false
          }
        })
      } else {
        this.spinShow1 = false
      }
    },
    userInfoInputFlag: function(newObj, oldObj) {
      this.spinShow2 = true
      if (newObj) {
        const userInfo = JSON.parse(this.$store.getters['menu/getUSERINFO'])
        getUserDetail({
          userId: userInfo.vUserId
        }).then(res => {
          if (res.data.code === '0000') {
            this.userInfomodify = res.data.info
            this.spinShow2 = false
          }
        })
      } else {
        this.spinShow2 = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./css/header.scss";
</style>